// extracted by css-extract-rspack-plugin
export default {"BetaLabel":"FloatField-module__BetaLabel__IJAOV"};